import { CustomCollapseCard, CustomImage, CustomTable, errorDialog, Text } from '@src/components';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/myInvoices/carInvoiceList.scss';
import save from '@src/assets/images/invoices/save.png';
import downloadIcon from '@src/assets/icons/download.svg';
import invoicePdf from '@src/assets/images/invoices/invoice.png';
import excel from '@src/assets/images/invoices/excel.png';
import { useDispatch, useSelector } from 'react-redux';
import { getPagedList } from '@src/store/slice/invoiceSlice';
import reportsServices from '@src/services/reports.services';
import invoicesServices from '@src/services/invoices.services';
import download from 'js-file-download';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { handleAuthStatus } from '@src/utils/utils';
import { Button } from 'antd';

const InvoiceList = () => {
  const dispatch = useDispatch();
  const { invoicesList } = useSelector((state) => state.invoice);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const isMobil = useMediaQuery({ query: '(max-width: 767.98px)' });
  const { userAuthorizationStatus } = useSelector((state) => state?.user);

  useEffect(() => {
    loadInvoiceList();
  }, [dispatch]);

  const loadInvoiceList = useCallback(() => {
    const body = {
      customerId: selectedCustomer?.customerId,
      vouId: 4,
    };

    dispatch(getPagedList({ body }));
  }, [dispatch, selectedCustomer]);

  const excelDownload = useCallback(
    async (record) => {
      let data = {
        customerId: selectedCustomer?.customerId,
        downloadType: 2,
        orderId: record?.orderNumber,
        vouId: record?.invoiceVouCode,
        invoiceId: record?.invoiceId,
      };
      let a = record?.invoiceDate.split('T')[0];
      let b = a.replaceAll('_', '/');

      try {
        const blob = await invoicesServices.downloadInvoiceFile(data);
        download(blob, `${record?.invoiceId} - ${b}.xlsx`);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [selectedCustomer],
  );

  const pdfDownload = useCallback(
    async (record) => {
      let data = {
        customerId: selectedCustomer?.customerId,
        orderId: record?.orderNumber,
        vouId: record?.invoiceVouCode,
        invoiceId: record?.invoiceId,
      };

      try {
        const blob = await reportsServices.getOrderSummaryPdfReport(data);
        download(blob, `${record?.invoiceId} - ${record?.invoiceDate.split('T')[0]}.pdf`);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [selectedCustomer],
  );

  const invoiceArchiveFileDownload = useCallback(
    async (record) => {
      let data = {
        customerId: selectedCustomer?.customerId,
        invoiceId: record?.invoiceId,
      };

      try {
        const blob = await invoicesServices.downloadInvoiceArchiveFile(data);
        download(blob, `${record?.invoiceId} - ${record?.invoiceDate.split('T')[0]}.pdf`);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [selectedCustomer],
  );

  const paymentInfo = (text) => {
    switch (text) {
      case 0:
        return <span><Text t="notPaid" /></span>;
      case 1:
        return <span><Text t="partiallyPaid" /></span>;
      case 2:
        return <span><Text t="paid" /></span>;
    }
  };

  const columns = [
    {
      title: <Text t="invoiceSerialNo" />,
      dataIndex: 'invoiceSerialNumber',
      key: 'invoiceSerialNumber',
      align: 'left',
      width: 98,
    },
    {
      title: <Text t="invoiceDate" />,
      dataIndex: 'invoiceDate',
      key: 'invoiceDate',
      width: 47,
      align: 'center',
      responsive: ['md'],
    },
    {
      title: <Text t="expiryDate" />,
      dataIndex: 'invoiceLimitDate',
      key: 'invoiceLimitDate',
      width: 40,
      align: 'center',
      responsive: ['md'],
    },
    {
      title: <Text t="excludesVat" />,
      dataIndex: 'withoutKDVAmount',
      key: 'withoutKDVAmount',
      width: 66,
      align: 'center',
      responsive: ['md'],
    },
    {
      title: <Text t="invoicePrice" />,
      dataIndex: 'totalInvoiceAmount',
      key: 'totalInvoiceAmount',
      width: 47,
      align: 'center',
      responsive: ['md'],
    },
    {
      title: <Text t="paymentInfo" />,
      dataIndex: 'icnPaymentStatu',
      key: 'icnPaymentStatu',
      width: 44,
      align: 'center',
      responsive: ['md'],
      render: (text) => {
        return <span>{paymentInfo(text)}</span>;
      },
    },
    {
      title: <Text t="unpaidAmount" />,
      dataIndex: 'balanceDue',
      key: 'balanceDue',
      width: 75,
      align: 'right',
      responsive: ['md'],
    },
  ];
  !handleAuthStatus(userAuthorizationStatus, 'MyInvoicesInvoiceExport') &&
    columns.push({
      title: '',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      align: 'center',
      responsive: ['md'],
      render: (_, record) => {
        return (
          <div className="invoice-actions">
            {record.fileExists === 1 ? (
              <CustomImage
                className="invoice-pdf"
                src={invoicePdf}
                onClick={() => invoiceArchiveFileDownload(record)}
              />
            ) : null}


            <Button
              className="download-button"
              onClick={() => {
                return pdfDownload(record);
              }}
              icon={<CustomImage src={downloadIcon} />}><Text t="saveBtn" />
              </Button>
            <CustomImage
              className="invoice-excel"
              src={excel}
              onClick={() => excelDownload(record)}
            />
          </div>
        );
      },
    });
  return (
    <CustomCollapseCard className="car-invoice-list-card" cardTitle={<Text t="invoices" />}>
      <CustomTable
        pagination={true}
        isScroll={!isMobil}
        dataSource={invoicesList}
        columns={columns}
        className="invoice-list-table"
        rowKey={(record) => `invoice-list-${record?.id}`}
      />
    </CustomCollapseCard>
  );
};

export default InvoiceList;
